import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { Module, MutationTree, GetterTree, ActionTree } from 'vuex';
import { RootState } from '@core/interfaces/root-state';

import { getProp, setProp } from '@shared/helpers/operators';
import { MediaState } from '@core/interfaces/media-state';
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import { bpcApi } from '@core/services/bpc-api.service';

const bpcRouterHelper = new BPCApiRouteHelper();

// Initial state
const state: MediaState = {
  medias: {},
  loading: false,
};

// Synchronous functions to get data from state (can be composed properties)
const getters: GetterTree<MediaState, RootState> = {
  isLoading(state): boolean {
    return !!state.loading;
  },
  media: state => (id: string) => {
    return getProp(state.medias, id);
  },
  statusMedia: state => (id: string) => {
    return getProp(state.medias, `${id}.deleted`);
  },
};

// Asynchornous functions to get data usually from an api call
const actions: ActionTree<MediaState, RootState> = {
  // Delete a media file
  deleteMedia({ commit, getters }, payload): Promise<any> {
    commit('startLoading');

    return new Promise((resolve, reject) => {
      const deleteMediaFilePath = bpcRouterHelper.getMediaFileDeleteEntityPath(
        payload.entity,
        payload.entityId,
        payload.mediaId,
      );

      bpcApi.delete(deleteMediaFilePath).subscribe(
        (res: BPCGenericApiResponse) => {
          commit('deletedMedia', { id: payload.mediaId, deleted: true });
          resolve({ data: true });
        },
        error => {
          commit('stopLoading');
          reject(error);
        },
        () => {
          commit('stopLoading');
          resolve({ data: true });
        },
      );
    });
  },
};

// The vuex way of changing a state property
const mutations: MutationTree<MediaState> = {
  stopLoading(state) {
    state.loading = false;
  },
  startLoading(state) {
    state.loading = true;
  },
  storeMedia(state, payload) {
    setProp(state.medias, payload.id, payload.media);
  },
  deletedMedia(state, payload) {
    setProp(state.medias, `${payload.id}.deleted`, payload.deleted);
  },
};

export const MediaStoreModule: Module<MediaState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
